import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';

class CheckoutItems extends React.Component {

    constructor(props){
        super(props);
        this.handleSelect = this.handleSelect.bind(this);
    }

    onClick(e) {
        console.log(e);
    }

    handleSelect(e){
        console.log(e);
    }
    render() {
        return (

            <React.Fragment>

                <div className="container scannedItemList">
                    {/* <Dropdown show onSelect={(e) => this.handleSelect(e)}>
                        <Dropdown.Header>Scanned Items</Dropdown.Header>
                        <Dropdown.Item eventKey="2">Another action</Dropdown.Item>
                        <Dropdown.Item eventKey="3">Something else here</Dropdown.Item>
                    </Dropdown> */}
                    <ul>
                    {
                        this.props.currentSale.map((product, i) =>
                        <li key={i} id={product.barcode} className="list-group-item d-flex  align-items-center">
                            {product.name}....£{product.sale_price}                                               
                        </li>)
                    }

                    </ul>


                </div>
            </React.Fragment>
            
        )
    }

}
export default CheckoutItems